<template>
    <b-container fluid>
        <iq-card>
            <template v-slot:headerTitle>
                <h4 class="card-title">{{ $t('social_service.hospital_top_seat') }} {{ $t('globalTrans.search') }}</h4>
            </template>
            <template v-slot:body>
                <b-overlay :show="unitLoad">
                <b-row>
          <b-col xl="12" lg="12" sm="12">
            <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
              <b-form  @submit.prevent="handleSubmit(searchData)" @reset.prevent="reset" enctype="multipart/form-data">
                <b-row>
                  <!-- Year -->
                  <b-col xl="6" lg="6" sm="12">
                    <ValidationProvider name="year" vid="fiscal_year_id" rules="required|min_value:1">
                        <b-form-group
                          class="row"
                          label-cols-sm="3"
                          label-for="fiscal_year_id"
                          slot-scope="{ valid, errors }"
                        >
                        <template v-slot:label>
                          {{$t('retailerManagement.year')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-select
                          plain
                          v-model="search.year_id"
                          :options="yearList"
                          id="fiscal_year_id"
                          :state="errors[0] ? false : (valid ? true : null)"
                        >
                        <template v-slot:first>
                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                        </b-form-group>
                    </ValidationProvider>
                  </b-col>

                  <!-- Month -->
                  <b-col xl="6" lg="6" sm="12">
                    <ValidationProvider name="Month" vid="month_id" rules="required|min_value:1">
                        <b-form-group
                          class="row"
                          label-cols-sm="3"
                          label-for="month_id"
                          slot-scope="{ valid, errors }"
                        >
                        <template v-slot:label>
                          {{$t('production_store.month')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-select
                          plain
                          v-model="search.month_id"
                          :options="monthList"
                          id="month_id"
                          :state="errors[0] ? false : (valid ? true : null)"
                        >
                        <template v-slot:first>
                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                        </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- Search Button -->
                  <b-col xl="12" lg="12" sm="12">
                    <div class="col text-right">
                      <b-button type="submit" variant="primary" class="mr-2">{{ $t('globalTrans.search') }}</b-button>
                    </div>
                  </b-col>
                </b-row>
              </b-form>
            </ValidationObserver>
          </b-col>
        </b-row>
                </b-overlay>
            </template>
        </iq-card>
        <iq-card>
            <template slot:body>
                <div class="col-md-12" >
                    <!-- report head data -->
                    <b-row v-if="reportHeadData">
                        <b-col xs="12" sm="12" md="12" class="text-right">
                            <b-button-group>
                                <b-button variant="success" @click="pdfExport">
                                    <i style="font-size: 18px; margin: 0; padding: 0;" class="ri-printer-fill"></i>
                                </b-button>
                            </b-button-group>
                        </b-col>
                    </b-row>
                    <b-row v-if="reportHeadData">
                        <b-col xs="12" sm="12" md="3" class="text-right mt-3">
                            <b-img :src="`${ reportHeadData.reportHeadColumn[0].image }`" fluid alt="BD Image" style="width:35%;border-radius:50%;"></b-img>
                        </b-col>
                        <b-col xs="12" sm="12" md="6" class="text-center mt-2">
                            <h3 class="text-bold">
                                {{ $t('production_store.govt_info') }}
                            </h3>
                            <h4 class="text-center text-dark">
                                {{ $t('social_service.dss') }}
                            </h4>
                            <!-- <span class="text-center text-dark">
                                {{ reportHeadData.heading }}
                            </span><br> -->
                            <span class="text-center text-dark">
                                {{ reportHeadData.address }}
                            </span><br>
                            <div class="titleDiv">
                                <span class="text-center text-dark reportTitle" style="font-weight:bold;">
                                 {{ $t('social_service.hospital_social_service_activities') }} {{ getMonthNameById(search.month_id) }}' {{ getYearName(search.year_id) }} {{ $t('social_service.hia') }}
                                </span><br>
                            </div>
                        </b-col>
                        <b-col xs="12" sm="12" md="3" class="text-left mt-3">
                            <b-img :src="`${ reportHeadData.reportHeadColumn[1].image }`" fluid alt="BD Image" style="width:35%;border-radius:50%;"></b-img>
                        </b-col>
                    </b-row>
                    <b-overlay :show="unitLoad">
                    <!-- report head data -->
                    <b-row v-if="isShowCashRegister && reportHeadData">
                        <b-col xs="12" sm="12" md="6" class="text-left">
                            <span v-if="titleData.year" class="text-center text-dark"><b>{{ $t('report.year') }} </b>: {{ titleData.year }}</span> <br>
                            <span v-if="titleData.monthName" class="text-center text-dark"><b>{{ $t('report.month_name') }} </b>: {{ titleData.monthName }}</span>
                        </b-col>
                        <b-col xs="12" sm="12" md="6" class="text-right">
                            <span v-if="titleData.hosName" class="text-center text-dark"><b>{{ $t('social_service.hospital') }}</b>: {{ titleData.hosName }}</span>
                        </b-col>
                        <b-col md="12" class="table-responsive">
                            <b-table-simple  bordered hover responsive class="mt-4">
                                <b-tr>
                                    <b-th style="width: 5%">{{$n(1)}}</b-th>
                                    <b-td style="width: 35%">{{ $t('social_service.total_number_of_units_patient_welfare_societies_formed') }}</b-td>
                                    <b-td style="width: 1%">:</b-td>
                                    <b-td style="width: 50%" colspan="4">
                                    {{ $t('social_service.district_level') }} = {{ $n(jelaHos()) }} {{ $t('social_service.the') }}<br>
                                    {{ $t('social_service.upazila_level') }} = {{ $n(upajelaHos()) }} {{ $t('social_service.the') }}<br>
                                    {{ $t('social_service.total_units') }} = {{ $n(jelaHos() +  upajelaHos()) }} {{ $t('social_service.the') }}<br>
                                    {{ $t('social_service.govt_hospital') }} = {{ $n(govHos()) }} {{ $t('social_service.the') }}<br>
                                    {{ $t('social_service.private_hospital') }} = {{ $n(privateHos()) }} {{ $t('social_service.the') }}<br>
                                    {{ $t('social_service.medical_college_hospital') }} = {{ $n(medicaleHos()) }} {{ $t('social_service.the') }}<br>
                                    {{ $t('social_service.specialized_hospital') }} = {{ $n(specialHos()) }} {{ $t('social_service.the') }}<br>
                                    {{ $t('social_service.general_hospital') }} = {{ $n(genaralHos()) }} {{ $t('social_service.the') }}<br>
                                    {{ $t('social_service.upazila_health_complex') }} = {{ $n(upazilaHos()) }} {{ $t('social_service.the') }}<br>
                                    {{ $t('social_service.94_nit_hospital_social_service_officer') }} {{ $t('social_service.the') }}
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-th rowspan="3">{{$n(2)}}</b-th>
                                    <b-td rowspan="3">{{ getMonthNameById(search.month_id) }}' {{ getYearName(search.year_id) }} {{ $t('social_service.number_patients_receiving_financial') }}</b-td>
                                    <b-td rowspan="3">:</b-td>
                                    <b-td colspan="4"> {{ getMonthNameById(search.month_id) }}' {{ getYearName(search.year_id) }} {{ $t('social_service.number_of_patients_benefited') }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td>{{ $t('social_service.financial1') }}</b-td>
                                    <b-td>{{ $t('social_service.social') }}</b-td>
                                    <b-td>{{ $t('social_service.rehabilitation1') }}</b-td>
                                    <b-td>{{ $t('globalTrans.total') }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td>{{ $n(allData.twoA) }}</b-td>
                                    <b-td>{{ $n(allData.twoS) }}</b-td>
                                    <b-td>{{ $n(allData.twoP) }}</b-td>
                                    <b-td>{{ $n(allData.twoA + allData.twoS + allData.twoP) }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-th rowspan="3">{{$n(3)}}</b-th>
                                    <b-td rowspan="3">{{$i18n.locale === 'en' ? search2.fis.text_en : search2.fis.text_bn}} {{ $t('social_service.total_number_of_beneficiaries') }}</b-td>
                                    <b-td rowspan="3">:</b-td>
                                    <b-td colspan="4">{{ getMonthNameById(search.month_id) }}' {{ getYearName(search.year_id) }} {{ $t('social_service.number_of_patients_benefited') }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td>{{ $t('social_service.financial1') }}</b-td>
                                    <b-td>{{ $t('social_service.social') }}</b-td>
                                    <b-td>{{ $t('social_service.rehabilitation1') }}</b-td>
                                    <b-td>{{ $t('globalTrans.total') }}</b-td>
                                </b-tr>
                                 <b-tr>
                                    <b-td>{{ $n(allData.threeA) }}</b-td>
                                    <b-td>{{ $n(allData.threeS) }}</b-td>
                                    <b-td>{{ $n(allData.threeP) }}</b-td>
                                    <b-td>{{ $n(allData.threeA + allData.threeS + allData.threeP) }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-th>{{$n(4)}}</b-th>
                                    <b-td>{{ $t('social_service.from') }} {{ getMonthNameById(search.month_id) }}' {{ getYearName(search.year_id) }} {{ $t('social_service.number_of_patients_receiving_financial_assistance') }}</b-td>
                                    <b-td>:</b-td>
                                    <b-td colspan="4">{{ $n(allData.four) }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-th rowspan="4">{{$n(5)}}</b-th>
                                    <b-td rowspan="4">{{ getMonthNameById(search.month_id) }}' {{ getYearName(search.year_id) }} {{ $t('social_service.income_of_patient_welfare_associations') }}</b-td>
                                    <b-td rowspan="4">:</b-td>
                                    <b-td colspan="2">{{ $t('social_service.loc') }}</b-td>
                                    <b-td colspan="2">{{ $n(allData.fiveA) }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td colspan="2">{{ $t('social_service.mon') }}</b-td>
                                    <b-td colspan="2">{{ $n(allData.fiveB) }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td colspan="2">{{ $t('social_service.soc') }}</b-td>
                                    <b-td colspan="2">{{ $n(allData.fiveC) }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td colspan="2">{{ $t('social_service.tot_inc') }}</b-td>
                                    <b-td colspan="2">{{ $n(allData.fiveA + allData.fiveB + allData.fiveC) }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-th rowspan="4">{{$n(6)}}</b-th>
                                    <b-td rowspan="4">{{ getMonthNameById(search.month_id) }}' {{ getYearName(search.year_id) }} {{ $t('social_service.income_of_patient_welfare_associations_420') }}</b-td>
                                    <b-td rowspan="4">:</b-td>
                                    <b-td colspan="2">{{ $t('social_service.loc') }}</b-td>
                                    <b-td colspan="2">{{ $n(allData.sixA) }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td colspan="2">{{ $t('social_service.mon') }}</b-td>
                                    <b-td colspan="2">{{ $n(allData.sixB) }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td colspan="2">{{ $t('social_service.soc') }}</b-td>
                                    <b-td colspan="2">{{ $n(allData.sixC) }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td colspan="2">{{ $t('social_service.tot_inc') }}</b-td>
                                    <b-td colspan="2">{{ $n(allData.sixA + allData.sixB + allData.sixC) }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-th>{{$n(7)}}</b-th>
                                    <b-td>{{ getMonthNameById(search.month_id) }}' {{ getYearName(search.year_id) }} {{ $t('social_service.income_of_patient_welfare_associations_total') }}</b-td>
                                    <b-td>:</b-td>
                                    <b-td colspan="2">{{ $t('social_service.sum') }}</b-td>
                                    <b-td colspan="2">{{ $n(allData.fiveA + allData.fiveB + allData.fiveC + allData.sixA + allData.sixB + allData.sixC) }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-th rowspan="3">{{$n(8)}}</b-th>
                                    <b-td rowspan="3">{{$i18n.locale === 'en' ? search2.fis.text_en : search2.fis.text_bn}} {{ $t('social_service.total_income_from_reporting_month_financial_year') }}</b-td>
                                    <b-td rowspan="3">:</b-td>
                                    <b-td colspan="2">{{ $t('social_service.hos_inc') }}</b-td>
                                    <b-td colspan="2">{{ $n(allData.eightA) }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td colspan="2">{{ $t('social_service.leve_hos') }}</b-td>
                                    <b-td colspan="2">{{ $n(allData.eightB) }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td colspan="2">{{ $t('social_service.tot_income') }}</b-td>
                                    <b-td colspan="2">{{ $n(allData.eightA + allData.eightB) }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-th rowspan="3">{{$n(9)}}</b-th>
                                    <b-td rowspan="3">{{ getMonthNameById(search.month_id) }}' {{ getYearName(search.year_id) }} {{ $t('social_service.total_expenditure_patient_welfare_societies') }}</b-td>
                                    <b-td rowspan="3">:</b-td>
                                    <b-td colspan="2">{{ $t('social_service.oe_tot_expen') }}</b-td>
                                    <b-td colspan="2">{{ $n(allData.nineA) }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td colspan="2">{{ $t('social_service.ft_tot_expen') }}</b-td>
                                    <b-td colspan="2">{{ $n(allData.nineB) }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td colspan="2">{{ $t('social_service.te') }}</b-td>
                                    <b-td colspan="2">{{ $n(allData.nineA + allData.nineB) }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-th rowspan="3">{{$n(10)}}</b-th>
                                    <b-td rowspan="3">{{$i18n.locale === 'en' ? search2.fis.text_en : search2.fis.text_bn}} {{ $t('social_service.total_expenditure_from_reporting_month_financial_year') }}</b-td>
                                    <b-td rowspan="3">:</b-td>
                                    <b-td colspan="2">{{ $t('social_service.patient_welfare_a_e') }}</b-td>
                                    <b-td colspan="2">{{ $n(allData.tenA) }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td colspan="2">{{ $t('social_service.patient_welfare') }}</b-td>
                                    <b-td colspan="2">{{ $n(allData.tenB) }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td colspan="2">{{ $t('social_service.te') }}</b-td>
                                    <b-td colspan="2">{{ $n(allData.tenA + allData.tenB) }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-th rowspan="5">{{$n(11)}}</b-th>
                                    <b-td rowspan="4">{{ $t('social_service.current_bank_status') }}</b-td>
                                    <b-td rowspan="4">:</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td colspan="2">{{ $t('social_service.oe_bs') }}</b-td>
                                    <b-td colspan="2">{{ $n(allData.elevenA) }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td colspan="2">{{ $t('social_service.ft_bi') }}</b-td>
                                    <b-td colspan="2">{{ $n(allData.elevenB) }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td colspan="2">{{ $t('social_service.tba') }}</b-td>
                                    <b-td colspan="2">{{ $n(allData.elevenA + allData.elevenB) }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td>{{ $t('social_service.current_status') }}</b-td>
                                    <b-td>:</b-td>
                                    <b-td colspan="2">{{ $t('social_service.current_status1') }}</b-td>
                                    <b-td colspan="2">{{ $n(allData.elevenC) }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-th rowspan="3">{{$n(12)}}</b-th>
                                    <b-td rowspan="3">{{$i18n.locale === 'en' ? search2.fis.text_en : search2.fis.text_bn}} {{ $t('social_service.grants_by_national_social_welfare_council_during_financial_year') }}</b-td>
                                    <b-td rowspan="3">:</b-td>
                                    <b-td colspan="2">{{ $t('social_service.national_social_grant_108_hospitals') }}</b-td>
                                    <b-td colspan="2">{{ $n(allData.twelveA) }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td colspan="2">{{ $t('social_service.national_social_grant_420_hospitals') }}</b-td>
                                    <b-td colspan="2">{{ $n(allData.twelveB) }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td colspan="2">{{ $t('social_service.tga') }}</b-td>
                                    <b-td colspan="2">{{ $n(allData.twelveA +  allData.twelveB) }}</b-td>
                                </b-tr>
                            </b-table-simple>
                        </b-col>
                    </b-row>
                    </b-overlay>
                </div>
            </template>
        </iq-card>
<!--        <b-modal id="modal-detail-umo" size="xl" :title="detailTitle" :ok-title="$t('globalTrans.close')" ok-only-->
<!--                 ok-variant="danger">-->
<!--            <DetailModalUMO :id="editItemId" :key="editItemId" :item="item"/>-->
<!--        </b-modal>-->
    </b-container>
</template>
<script>
// import DetailModalUMO from './DetailModalUMO'
import RestApi, { hospitalServiceBaseUrl } from '@/config/api_config'
import { socialServiceHospitalTopSheetReportApi, assignUserHospitalApi } from '../../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'
import iqCard from '../../../../../../components/core/cards/iq-card.vue'
import ReportHeading from '@/Utils/report-head'
import ExportPdf from './export-pdf-details'
export default {
  components: { iqCard },
    mixins: [ModalBaseMasterList],
    // components: {
    //     DetailModalUMO
    // },
    data () {
        return {
            sysCall: 0,
            hospitalList: [],
            hospitalIds: [],
            userId: 0,
            search: {
                month_id: new Date().getMonth() + 1,
                year_id: this.$store.state.commonObj.fiscalYearList.find(item => item.value === this.$store.state.currentFiscalYearId).text_en.split('-')[1]
            },
            search2: {
                fis_id: 0,
                fis: 'All'
            },
            titleData: {
                year: '',
                monthName: '',
                hosName: ''
            },
            bankCharge: 0,
            editItemId: '',
            item: '',
            rows: [],
            districtList: [],
            upazillaList: [],
            bankAncester: 0,
            handAncester: 0,
            monthWithdraw: 0,
            monthDeposit: 0,
            monthExpense: 0,
            monthAllExpenses: [],
            monthAllDeposit: [],
            isShowCashRegister: false,
            cashRegister: [],
            allData: [],
            reportHeadData: null,
            unitLoad: false
        }
    },
    created () {
        // this.search.year_id = this.$store.state.commonObj.fiscalYearList.find(item => item.value === this.$store.state.currentFiscalYearId)text_en.split('-')[1]
        this.searchData()
    },
    computed: {
        hospitalAllList: function () {
            return this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1)
        },
        formTitle () {
            return (this.editItemId === 0) ? this.$t('social_service.dashbboard') + ' ' + this.$t('globalTrans.entry') : this.$t('social_service.dashbboard') + ' ' + this.$t('globalTrans.modify')
        },
        detailTitle () {
            return 'Detail Title'
        },
        divisionList: function () {
            return this.$store.state.commonObj.divisionList.filter(item => item.status === 0)
        },
        monthList: function () {
            const objectData = this.$store.state.commonObj.monthList
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return {
                        value: obj.value,
                        text: obj.text_bn
                    }
                } else {
                    return {
                        value: obj.value,
                        text: obj.text_en
                    }
                }
            })
        },
        MonthList: function () {
            const list = [
                {
                    value: 1,
                    text: this.$t('months.jan')
                },
                {
                    value: 2,
                    text: this.$t('months.feb')
                },
                {
                    value: 3,
                    text: this.$t('months.mar')
                },
                {
                    value: 4,
                    text: this.$t('months.apr')
                },
                {
                    value: 5,
                    text: this.$t('months.may')
                },
                {
                    value: 6,
                    text: this.$t('months.jun')
                },
                {
                    value: 7,
                    text: this.$t('months.jul')
                },
                {
                    value: 8,
                    text: this.$t('months.aug')
                },
                {
                    value: 9,
                    text: this.$t('months.sep')
                },
                {
                    value: 10,
                    text: this.$t('months.oct')
                },
                {
                    value: 11,
                    text: this.$t('months.nov')
                },
                {
                    value: 12,
                    text: this.$t('months.dec')
                }
            ]
            return list
        },
        yearList: function () {
            const data = this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
            const years = data.map((obj, key) => {
                const year = obj.text
                return { value: obj.text_en.split('-')[1], text: year }
            })
            // Getting the last year on the end of the Fiscal Year List
            // const lastYear = (data[data.length - 1].text.split('-')[1])
            // years.push({ value: lastYear, text: lastYear })
            return years
        },
        fiscalyearList: function () {
            return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
        }
    },
    watch: {
        loadingState: function (newVal, oldVal) {
            if (newVal) {
                this.loadData()
            }
        },
        'search.year_id': function (newVal, OldVal) {
            if (newVal !== OldVal) {
                this.getFiscalYear()
            }
        },
        'search.month_id': function (newVal, OldVal) {
            if (newVal !== OldVal) {
                this.getMonthName()
            }
        }
    },
    methods: {
        jelaHos () {
            const objectData = this.hospitalAllList.filter(item => item.category < 4)
                return objectData.length
        },
        upajelaHos () {
            const objectData = this.hospitalAllList.filter(item => item.category === 4)
                return objectData.length
        },
        privateHos () {
            const objectData = this.hospitalAllList.filter(item => item.hospital_class_id === 2 && item.category < 5)
                return objectData.length
        },
        govHos () {
            const objectData = this.hospitalAllList.filter(item => item.hospital_class_id === 1 && item.category < 5)
                return objectData.length
        },
        medicaleHos () {
            const objectData = this.hospitalAllList.filter(item => item.category === 1)
                return objectData.length
        },
        specialHos () {
            const objectData = this.hospitalAllList.filter(item => item.category === 2)
                return objectData.length
        },
        genaralHos () {
            const objectData = this.hospitalAllList.filter(item => item.category === 3)
                return objectData.length
        },
        upazilaHos () {
            const objectData = this.hospitalAllList.filter(item => item.category === 4)
            return objectData.length
        },

        three (hosId) {
            let total = 0
            this.allData.three.find(item => item.hospital_id === parseInt(hosId))
            this.allData.three.map((obj, key) => {
                if (obj.hospital_id === parseInt(hosId)) {
                    total = obj.three
                }
            })
            return total
        },
        async getUserWiseHospital (userId) {
            const params = Object.assign({ user_id: userId })
            const result = await RestApi.getData(hospitalServiceBaseUrl, assignUserHospitalApi, params)
            if (result.success) {
                    this.hospitalIds = result.data
            } else {
                this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1).map((obj, key) => {
                    this.hospitalIds.push(obj.value)
                })
            }
            this.hospitalList = this.getHospitalList()
        },
        getHospitalList () {
            let hospitalList = this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1)
            if (this.hospitalIds.length > 0) {
            hospitalList = hospitalList.filter((p) => this.hospitalIds.includes(p.value))
            }
            this.hospitalLoad = false
            this.unitLoad = false
            return hospitalList
        },
        async headerName () {
            this.loadingReportHeadData = true
            const result = await ReportHeading.getReportHead(hospitalServiceBaseUrl, 'configuration/report-heading/detail', 3)
            this.reportHeadData = result
            this.loadingReportHeadData = false
            this.unitLoad = false
        },
        monthNameById () {
            const unit = this.MonthList.find(unit => unit.value === this.search.month_id)
            if (this.$i18n.locale === 'bn') {
                return unit.text
            } else {
                return unit.text
            }
        },
        getDistrictListByDivisionId (divisionId = null) {
            return this.$store.state.commonObj.districtList.filter(item => item.status === 0 && item.division_id === divisionId)
        },
        getHospitalListByDistrictId (districtId = null) {
            return this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1 && item.district_id === districtId)
        },
        getYearName (yId) {
            const monthObj = this.$store.state.commonObj.fiscalYearList.find(item => item.value === parseInt(this.search2.fis_id))
            if (this.search.month_id > 6) {
                return monthObj.text.split('-')[0]
            } else {
                return monthObj.text.split('-')[1]
            }
        },
        getMonthNameById (id) {
            const Month = this.$store.state.commonObj.monthList.find(item => item.value === parseInt(id))
            if (this.$i18n.locale === 'bn') {
                return Month.text_bn
            } else {
                return Month.text_en
            }
        },
        searchData () {
           // this.$bvModal.show('modal-detail-umo')
            this.loadData()
        },
        edit (item) {
            this.editItemId = item.id
            this.item = item
        },
        loadData () {
            this.unitLoad = true
            this.search2.fis_id = this.$store.state.commonObj.fiscalYearList.find(obj => obj.text_en.split('-')[1] === this.search.year_id).value
            this.search2.fis = this.$store.state.commonObj.fiscalYearList.find(obj => obj.text_en.split('-')[1] === this.search.year_id)
            if (this.search.year_id !== 0 && this.search.month_id !== 0) {
                RestApi.getData(hospitalServiceBaseUrl, socialServiceHospitalTopSheetReportApi, this.search).then(response => {
                    if (response.success) {
                        this.allData = response.data
                        this.isShowCashRegister = true
                        this.headerName()
                    }
                })
            }
        },
        getRelationalData (data) {
            const listData = data.map(item => {
                const designationData = {
                    designation: item.designation_bn !== undefined ? item.designation : '',
                    designation_bn: item.designation !== undefined ? item.designation_bn : ''
                }

                return Object.assign({}, item, designationData)
            })
            return listData
        },
        getFiscalYear () {
            const Year = this.yearList.find(item => item.value === this.search.year_id)
            this.titleData.year = Year.text
        },
        getMonthName () {
            const Month = this.monthList.find(item => item.value === this.search.month_id)
            if (this.$i18n.locale === 'bn') {
                this.titleData.monthName = Month.text
            } else {
                this.titleData.monthName = Month.text
            }
        },
        getHospitalName (id) {
            const Hospital = this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.find(item => item.value === parseInt(id))
            if (this.$i18n.locale === 'bn') {
                return Hospital.text_bn
            } else {
                return Hospital.text_en
            }
        },
        pdfExport () {
            const reportTitle = this.$t('social_service.hospital_social_service_activities') + ' ' + this.getMonthNameById(this.search.month_id) + ' ' + this.getYearName(this.search.year_id) + ' ' + this.$t('social_service.hia')
            ExportPdf.exportPdfDetails(hospitalServiceBaseUrl, 'configuration/report-heading/detail', 3, reportTitle, this.allData, this, this.titleData)
        }
    }
}
</script>
<style scoped>
    .titleDiv {
        font-size: 18px;
    }
    .text-message {
        font-weight: bold;
        font-size: 24px;
        color: rgba(63, 62, 62, 0.418);
    }
</style>
